import createDecorator from 'final-form-calculate';
import dataPicker from '../../libs/admin/data_picker';

const handleChange = () => {
  const trigger = () => {
    $('@dropDown').dropdown();
    dataPicker();
  };
  setTimeout(trigger, 100);
};

const decorator = createDecorator(
  {
    field: 'kind',
    updates: {
      required_amount: (name) => {
        switch (name) {
          case 'survive':
            return '2x3';
          default:
            return '6x3';
        }
      },
      ends_at: (name, allValues) => {
        const { defaultEnd: customEnd, ends_at: endsAt } = allValues;

        if ((endsAt === undefined || endsAt === '') && name === 'survive') {
          return customEnd;
        } else if ((endsAt !== undefined || endsAt !== '') && name === 'survive') {
          return endsAt;
        } else if (endsAt !== customEnd && name === 'weekly') {
          return endsAt;
        }
        return '';
      },
    },
  },
  {
    field: 'required_amount',
    updates: {
      stat_categories: (name) => {
        handleChange();
        switch (name) {
          case '1x3':
          case '1x2':
            return [
              {
                subject: '',
                amount: '',
              },
            ];
          case '2x1':
          case '2x2':
          case '2x3':
            return [
              {
                subject: '',
                amount: '',
              },
              {
                subject: '',
                amount: '',
              },
            ];
          case '3x1':
          case '3x2':
            return [
              {
                subject: '',
                amount: '',
              },
              {
                subject: '',
                amount: '',
              },
              {
                subject: '',
                amount: '',
              },
            ];
          case '6x3':
            return [
              {
                subject: '',
                amount: '',
              },
              {
                subject: '',
                amount: '',
              },
              {
                subject: '',
                amount: '',
              },
              {
                subject: '',
                amount: '',
              },
              {
                subject: '',
                amount: '',
              },
              {
                subject: '',
                amount: '',
              },
            ];
          default:
            break;
        }
      },
    },
  },
);

export default decorator;
